import script from "./DisconnectModule.vue?vue&type=script&setup=true&lang=js"
export * from "./DisconnectModule.vue?vue&type=script&setup=true&lang=js"

import "./DisconnectModule.vue?vue&type=style&index=0&id=1c9908eb&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c9908eb"]])

export default __exports__